import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Miner from './views/Miner.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/miner',
      name: 'miner',
      component: Miner
    }
  ]
})
